import { useLocation } from 'react-router-dom';

import classy from '@core/utils/classy';

import classes from '../../style.module.scss';
import { isNavItemActive, NavLinkWrapper } from '../NavLinks';

interface LinkItemProps {
  item: {
    text?: string;
    title?: string;
    type?: string;
  };
}

const LinkItem = ({ item }: LinkItemProps) => {
  const { pathname } = useLocation();
  return (
    <NavLinkWrapper
      className={classy(
        'rm-Header-link',
        'rm-Header-top-link',
        'Button_slate_text',
        item.type !== 'url' && isNavItemActive(item, pathname) ? 'rm-Header-top-link_active' : '',
        classes['Header-link'],
      )}
      item={item}
    >
      {item.text || item.type}
    </NavLinkWrapper>
  );
};

export default LinkItem;
